module.exports = __webpack_public_path__ + "assets/img/imgbig_yhqh2.e6e8cc4d.jpg";